/** Virtual invoice sort field: the customer's company name (not a column). */
export const INVOICE_CUSTOMER_SORT_FIELD = "customer_name";
